import { Dictionary } from 'utils/Dictionary'
import Swiper, { Autoplay, Controller, Navigation, Pagination, Parallax } from 'swiper'

Swiper.use([Autoplay, Controller, Navigation, Pagination, Parallax])

const galleryImages = {
  el: {
    sliders: document.querySelectorAll<HTMLElement>('.image-gallery-block'),
  },

  translation: {
    slide: Dictionary('genImage'),
  },

  init(): void {
    if (this.el.sliders) {
      Array.prototype.forEach.call(this.el.sliders, (item) => {
        console.log(item)
        this.initSwipers(item)
      })
    }
  },

  initSwipers(item): void {
    // @ts-ignore
    const isSingleSlide = item.querySelectorAll('.swiper-slide').length <= 1

    console.log(isSingleSlide)

    if (isSingleSlide) {
      item.classList.add('image-gallery-block--single-slide')
    }

    const swipr = <HTMLElement>item.querySelector('.image-gallery-block__swiper')
    const pagination = <HTMLElement>item.querySelector('.image-gallery-block__pagination')
    const next = item.querySelector('.image-gallery-block-button--next')
    const prev = item.querySelector('.image-gallery-block-button--prev')

    const BREAKPOINTS = {
      775: {
        spaceBetween: 30,
      },
    }

    const SPACEBETWEEN = 15

    // @ts-ignore
    const swiper = new Swiper(swipr, {
      allowTouchMove: !isSingleSlide,
      autoHeight: false,
      loop: !isSingleSlide,
      loopFillGroupWithBlank: false,
      breakpoints: BREAKPOINTS,
      grabCursor: !isSingleSlide,
      navigation: {
        nextEl: next,
        prevEl: prev,
        disabledClass: 'button--disabled',
      },
      pagination: {
        bulletActiveClass: 'image-gallery-block__image--small--active',
        bulletClass: 'image-gallery-block__image--small',
        bulletElement: 'button',
        clickable: true,
        el: pagination,
        renderBullet: (index, className) =>
          `<button class="image-gallery-block__image--small ${className}" aria-label="${this.translation.slide} ${
            index + 1
          }"></button>`,
        type: 'bullets',
      },
      parallax: true,
      spaceBetween: SPACEBETWEEN,
      speed: 800,
    })

    this.parseThumbs(item)
  },

  parseThumbs(item) {
    let html = ''
    const thumbs = item.dataset.thumbs
    const split = thumbs.split(';')

    Array.prototype.forEach.call(
      item.querySelectorAll('.image-gallery-block__image--small'),
      (a: HTMLElement, index: number) => {
        html = `<img src="${split[index]}" loading="lazy" alt="${split[index]}" decoding="async" width="60" height="60" />`

        a.innerHTML = html
      }
    )
  },
}

export default galleryImages
